export default __webpack_public_path__ + "static/media/Fatal Concoction.c74d4611.jpg";